import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SESSION_TIMEOUT_OPTIONS } from '../constants';
export function SecuritySettings({ security, onSecurityChange }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "space-y-6",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text-lg font-medium text-foreground mb-4",
                    children: "Security Settings"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-6",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("label", {
                                    className: "block text-sm font-medium text-foreground mb-1",
                                    children: "Session Timeout (minutes)"
                                }),
                                /*#__PURE__*/ _jsx("select", {
                                    value: security.sessionTimeout,
                                    onChange: (e)=>onSecurityChange('sessionTimeout', Number.parseInt(e.target.value)),
                                    className: "w-full border border-input rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-ring",
                                    children: SESSION_TIMEOUT_OPTIONS.map((option)=>/*#__PURE__*/ _jsx("option", {
                                            value: option.value,
                                            children: option.label
                                        }, option.value))
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("label", {
                                            className: "text-sm font-medium text-foreground",
                                            children: "Login Notifications"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "text-sm text-muted-foreground",
                                            children: "Get notified when someone logs into your account"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: ()=>onSecurityChange('loginNotifications', !security.loginNotifications),
                                    className: `relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${security.loginNotifications ? 'bg-primary' : 'bg-muted'}`,
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: `inline-block h-4 w-4 transform rounded-full bg-card transition-transform ${security.loginNotifications ? 'translate-x-6' : 'translate-x-1'}`
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
